import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { ConversationRoutes } from 'pages/conversations'

export const ChatbotAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.chatbot}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
